import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import "katex/dist/katex.min.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";
import "./i18n";

// const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
// TagManager.initialize({ gtmId });

const devMode = import.meta.env.VITE_IS_DEBUG;
if (devMode !== "true") {
  Sentry.init({
    dsn: "https://7c51165eeeae20f857513ad285bba9c9@o4508133136662528.ingest.us.sentry.io/4510715839774720",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.facetflux\.com\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  console.debug("Dev mode, no Sentry init...");
}

const trackingKey = import.meta.env.VITE_MIXPANEL_TRACKING_KEY;
if (devMode === "true") {
  mixpanel.init(trackingKey, {
    debug: true,
    track_pageview: true,
    ignore_dnt: false,
    persistence: "localStorage",
  });
  console.warn("TRACKING IN DEV MODE!");
} else {
  mixpanel.init(trackingKey, {
    debug: false,
    track_pageview: true,
    ignore_dnt: true,
    persistence: "localStorage",
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
